import React, { useContext, useEffect, useState } from 'react';
import { useI18N } from "../../../my-puratos/hoc/withI18N";
import { RELATED_PRODUCTS_KEY, RELATED_PRODUCTS_UPDATED_EVENT } from './RelatedProducts';
import { ProductContext } from '../../../pages/ProductStencil';
import { IProductStencilContext } from '../product-stencil.types';


export const RelatedProductsInformation = () => {
    const [relatedProductsCount, setRelatedProductsCount] = useState<number>(0);
    const translate = useI18N();
    const productData = useContext(ProductContext);
      const { hideAlternativeVariationsLabel,alternativeVariationsLabel,viewAlternativeVariationsLabel } = productData.product as IProductStencilContext["product"];

    useEffect(() => {
        const handleRelatedProductsUpdated = () => {
            const storedData = sessionStorage.getItem(RELATED_PRODUCTS_KEY);
            setRelatedProductsCount(storedData ? parseInt(storedData, 10) : 0);
        };
   
        window.addEventListener(RELATED_PRODUCTS_UPDATED_EVENT, handleRelatedProductsUpdated);
    }, []);

    const alternativeText = viewAlternativeVariationsLabel || 'View alternative flavours';
    const availbilityText = alternativeVariationsLabel || 'This item is available in {0} alternative flavours'

    if (!relatedProductsCount || hideAlternativeVariationsLabel) { return null; }
    return (
        <p className={"pdp-related-products-text"}>
            {translate(availbilityText, [relatedProductsCount])} <br/>
            <a href="#related-products">{translate(alternativeText)}</a>
        </p>
    );
};
